import type { StatusPedidoPublico } from '../api';

/** Situações em que o pedido acabou (mesmo recorte de `backend/src/lib/pager-totem.ts`). */
const SITUACOES_FINAIS = ['ENTREGUE', 'CANCELADO', 'FALHA_ENVIO'];

export function pedidoFinalizado(situacao: string): boolean {
  return SITUACOES_FINAIS.includes(situacao);
}

export interface ResumoAcompanhamento {
  rotulo: string;
  /** Etapa em que o cliente espera alguém agir — a faixa pulsa. */
  aguardando: boolean;
}

/**
 * Frase curta do status, do ponto de vista de quem pediu. Segue a leitura da tela de
 * acompanhamento (`pages/pedido-confirmado`): ENVIADO sem o carimbo de despacho é só
 * "a loja recebeu", e AGUARDANDO_RETIRADA em pedido de entrega é uso interno da loja.
 */
export function resumoAcompanhamento(
  pedido: Pick<StatusPedidoPublico, 'situacao' | 'payloadJson'>,
): ResumoAcompanhamento {
  const ehRetirada = pedido.payloadJson?.tipoDelivery === 'RETIRAR_LOCAL';
  const despachado = pedido.payloadJson?.despachadoEm != null;
  const { situacao } = pedido;

  if (situacao === 'AGUARDANDO_PAGAMENTO') return { rotulo: 'Aguardando pagamento', aguardando: true };
  if (despachado && !ehRetirada) return { rotulo: 'Saiu para entrega', aguardando: false };
  if (situacao === 'AGUARDANDO_RETIRADA' && ehRetirada) return { rotulo: 'Pronto para retirada', aguardando: false };
  if (situacao === 'PENDENTE' || (situacao === 'ENVIADO' && !despachado)) {
    return { rotulo: 'Aguardando a loja confirmar', aguardando: true };
  }
  return { rotulo: 'Confirmado · em preparo', aguardando: false };
}
